module.exports = __webpack_public_path__ + "static/gm-4-3eac0fa9c1f24b1dea9f052fca9e493b.jpg";